// src/layout/AppLayout/NavigationMenu.js
import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { MENU_ITEMS } from './constants';
import { StyledListItemButton } from './styles';

// Component for navigation menu
const NavigationMenu = ({ onItemClick }) => {
  const location = useLocation();
  
  const isActive = (path) => {
    return (
      location.pathname === path || 
      (path !== '/' && location.pathname.startsWith(path))
    ).toString();
  };

  return (
    <List>
      {MENU_ITEMS.map((item) => (
        <ListItem key={item.text} disablePadding>
          <StyledListItemButton
            component={Link}
            to={item.path}
            active={isActive(item.path)}
            onClick={onItemClick}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </StyledListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default NavigationMenu;